// frontend/src/services/legal.js
// Client for legal document and consent endpoints.

import { API_BASE } from "../config/api";
import { httpRequest } from "../utils/httpClient";
import { authService } from "./auth";

/**
 * Fetch the latest published legal document version metadata.
 */
export async function getCurrentLegalDocument() {
  const res = await httpRequest(`${API_BASE}/legal/current`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ detail: "Failed to load legal documents" }));
    throw new Error(error.detail || "Failed to load legal documents");
  }
  return res.json();
}

/**
 * Check whether the current user has accepted the latest legal version.
 */
export async function getConsentStatus() {
  const res = await httpRequest(`${API_BASE}/legal/consent/status`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authService.getAuthHeaders(),
    },
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ detail: "Failed to check consent status" }));
    throw new Error(error.detail || "Failed to check consent status");
  }
  return res.json();
}

/**
 * Record acceptance of a legal document version for the current user.
 */
export async function recordConsent(version) {
  const res = await httpRequest(`${API_BASE}/legal/consent`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authService.getAuthHeaders(),
    },
    body: JSON.stringify({ version }),
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ detail: "Failed to record consent" }));
    throw new Error(error.detail || "Failed to record consent");
  }
  return res.json();
}
